<template>
  <v-dialog
    id="modal-media-gallery"
    title="Media Gallery" 
    v-model="showMediaGallery"
    width="500"
  >
    <v-card :loading="loading">
      <v-card-title class="primary--text pr-4">
        Media Gallery
        <v-spacer />
        <v-btn icon color="grey" text @click="hide()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-row>
          <v-col md='3' 
            v-for="(image,idx) in filteredImages" 
            :key="'media'+idx"
          >
            <v-card >
              <v-img
                :src="image.url"
                height='100'
                contain
                @click="select(image)"
                >
              </v-img>
              <v-btn color="red" outlined dark center right @click="deleteMedia(image)"><v-icon>close</v-icon></v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-text-field hide-details outlined v-model="searchTerm" label="Filter" placeholder="Filter"></v-text-field>
        <v-spacer />
        <span v-if="errorMessage !== ''" class="ml-4 orange--text d-flex align-center">
          <v-icon color="orange" class="mr-2">error</v-icon>
          {{errorMessage}}
        </span>
        <v-spacer />
        <input ref="imageUploadInput" type="file" style="display:none" @input="upload">
        <v-btn color="primary"  @click="uploadclicked()" raised outlined>{{uploadText}} <v-icon right dark>mdi-cloud-upload</v-icon></v-btn>
        <v-btn color="red" @click="hide()" raised outlined>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex'
import request from '../../store/helpers'
export default {
  props:{
    isShown:false,
    type:0,
    userId:0,
    driverId:0,
    truckId:0
  },
  data(){
    return{
      loading:true,
      errorMessage: '',
      isUploading:false,
      isError:false,
      searchTerm:'',
      images : []
    }
  },
  model:{
    prop:'isShown',
    event:'changed'
  },
  computed:{
    ...mapState('settings',['baseApi']),
    showMediaGallery: {
      get(){
        return this.isShown
      },
      set(value){
        this.$emit('changed', value)
      }
    },
    filteredImages() {
      return this.images.filter(image => {
        return (this.searchTerm.toLowerCase() !== '') ? image.name.toLowerCase().includes(this.searchTerm) : true
      })
    },
    uploadText(){
      return this.isUploading? "Uploading ..." : "Upload"
    }
  },
  methods:{
    hide() {
      this.showMediaGallery = false
    },
    select(image) {
      if (!this.isUploading)
      {
        this.$emit("select", image);
        this.hide()
      }
    },
    uploadclicked(){
      const upload = this.$refs.imageUploadInput;
      upload.click();
    },
    upload() {
      if (!this.isUploading) {
        const file = this.$refs.imageUploadInput.files[0];

        if (file.type.includes("image/") || file.type.includes("video")) {
          if(this.driverId==null || this.driverId=="undefined"){
            this.driverId=0;
          }
          this.isUploading = true;
          this.isError = false;
          const form = new FormData();
          form.append("file", file);
          form.append('userId', this.userId)
          form.append('driverId', this.driverId)
          form.append('truckId',this.truckId)
          form.append('typeId',this.type)

          request({ method: 'post', url: 'media/upload', data: form, successCallback: image => { 
              
              this.$nextTick(() => {
          // Add the component back in
              this.images.push(image.value)
              this.isUploading = false 
        }); 
  
            }
          });
        } else {
          this.isError = true;
        }
      }
    },
    deleteMedia(media) {
      this.loading = true
      request({ method: 'delete', url: `media?id=${media.id}`, successCallback: image => {
              this.images.splice(this.images.indexOf(media), 1)
              this.loading = false
              this.$emit('mediaDeleted', media)
            }
          }).catch(e=>{
            console.log(e)
          })
    }
  },
  mounted() {
    // console.log("retrieving media items")
    axios({ 
            method: 'get', 
            url: `media/listByType?typeId=${this.type}`
          })
          .then(response=>{
            // console.log(response)
              this.images = response.data
              // console.log(this.images)
              this.loading = false
          })
          .catch(error=>console.log(error));
  }
}
</script>
<style lang="scss">
.v-card:not(.on-hover) {
  .deletebtn {
    visibility: hidden;
  } 
}
</style>